import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import md5 from 'md5';
import { Api, apiCall, fileDownload, getBaseProductInfoFromUrl } from '../../services';
import { useParams } from 'react-router-dom';
import { actionCreators } from '../../store';
import { useTranslate } from '../common/Translate';
import { SnackbarType } from '../../components/common/Snackbar';
import { TRANSLATIONS } from '../../constants';

export const useProductLoad = () => {
    const dispatch = useDispatch();
    const { articleNr, serial } = useParams();
    const translate = useTranslate();

    useEffect(() => {
        if (articleNr && serial) {
            (async () => {
                dispatch(actionCreators.setProductLoading(true));

                let productPromise = Promise.resolve();

                productPromise = handleProductGet(md5(`${articleNr}${serial}`));
           
                await productPromise;

                dispatch(actionCreators.setProductLoading(false));
            })();
        }
    }, [articleNr]);

    const handleProductGet = async (product: string) => {
        return apiCall(
            Api.getProduct(product),
            async x => {
                const product = x.data;
                dispatch(actionCreators.setInvalidProduct(false));
                dispatch(actionCreators.setProduct(product));
            }, 
            async () => {
                if (articleNr && serial) {
                    dispatch(actionCreators.setInvalidProduct(false));
                    dispatch(actionCreators.setProduct(getBaseProductInfoFromUrl(articleNr, serial)));
                    //dispatch(actionCreators.addSnackbar({ text: translate(TRANSLATIONS.snackbarMessages.cannotLoadProduct).toString(), type: SnackbarType.Error }));
                }
            }
        );
    };

    const handleFileGet = async (fileNameMd5: string, fileName: string) => {
        dispatch(actionCreators.setProductLoading(true));
        await fileDownload(
            Api.getDocument(fileNameMd5),
            async () => {
                dispatch(actionCreators.addSnackbar({ text: translate(TRANSLATIONS.snackbarMessages.cannotDownloadDocument), type: SnackbarType.Error }));
                },
                fileName
            );

        dispatch(actionCreators.setProductLoading(false));
    };

    return { handleFileGet };
};

